import _ from "lodash";
import { state } from "./state";

export const packagesRequests = (state) => {
  return _.filter(state.requests, (v) => v.type === "PACKAGE");
};
export const claimRequests = (state) => {
  return _.filter(state.requests, (v) => v.type === "CLAIM");
};

export const contactRequests = (state) => {
  return _.filter(state.requests, (v) => v.type === "CONTACT");
};
export const news = (state) => state.news;
export const users=(state)=>state.users;
export const newCategories = (state) => state.newCategories;
export const usersAdmin=(state)=>state.userAdmin